import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Radio, Tooltip, Tag
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    getMacEnrollmentSetting, updateMacEnrollmentSettingCustomWeb
} from "../../axios/api.enroll"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    settingId: string,
    updateSetting: () => void,
}

export const EnrollmentSettingCustomWeb = (props: propsModel) => {
    const { settingId, updateSetting } = props;
    const [dataForm] = Form.useForm();
    const [showTable, setShowTable] = useState<number>(1);
    const { t } = useTranslation();

    useEffect(() => {
        getDataInfo();
    }, [])

    const getDataInfo = () => {
        if(settingId)
        {
            getMacEnrollmentSetting(settingId).then((res) => {
                if (res && res != null) {
                    if(res.isCustomWebSetting)
                    {
                        setShowTable(2);
                        var data: any = {};
                        data.isMdmAdmin = res.isMdmAdmin;
                        data.loginItem = res.loginItem;
                        dataForm?.setFieldsValue(data);
                    }
                    else
                        setShowTable(1);
                }
            })
        }
    }
    const addTemplateClick = () => {
        if(!settingId)
        {
            notification.warning({ message: t("请先配置基本信息") });
            return;
        }
        dataForm?.validateFields().then(
            (res) => {
                var req: any = {};
                req.isMdmAdmin = res.isMdmAdmin;
                req.loginItem = res.loginItem;

                updateMacEnrollmentSettingCustomWeb(settingId, req).then(() => {
                    notification.success({ message: t("成功") });
                    //dataForm.resetFields();
                    getDataInfo();
                })
            })
    }
    const cancelClick = () => {
        dataForm?.resetFields();
        updateSetting();
        getDataInfo();
    }

    return (<>
        <div>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { setShowTable(2) }} type="primary">
                                {t("设置")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && <>
                    <Form
                        style={{ width: "90%", marginTop: 36 }}
                        layout="horizontal"
                        form={dataForm}
                        labelCol={{ span: 4 }}
                        initialValues={{isMdmAdmin: false,loginItem: "None"}}
                    >
                        <Form.Item
                            label={t("MDM管理员")}
                            name="isMdmAdmin"
                            rules={[
                                { 
                                required: true, 
                                message: t("请选择MDM管理员") 
                                }
                            ]}
                        >
                            <Select>
                                <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                                <Select.Option value={true}>{t("是")}</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={t("用户登录")}
                            name="loginItem"
                            rules={[
                                { 
                                required: true, 
                                message: t("请选择用户登录") 
                                }
                            ]}
                        >
                            <Select>
                                <Select.Option value={"None"}>{t("暂不设置")}</Select.Option>
                                <Select.Option value={"Feishu"}>{t("飞书")}</Select.Option>
                                <Select.Option value={"MdmUser"}>{t("MDM用户")}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Form>

                    <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                        <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                        <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { cancelClick(); }}>{t("取消")}</Button>
                    </div>
                    </>
                }

            </Row>
        </div>

    </>)
};